import { render, staticRenderFns } from "./PurE_Items.vue?vue&type=template&id=755b72cb"
import script from "./PurE_Items.vue?vue&type=script&lang=js"
export * from "./PurE_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports